import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/products-and-services-templates/new/loading';

export const Route = createFileRoute('/_private/settings/products-and-services-templates/new')({
  component: Loading,
});
